import { IUserModel } from 'src/interfaces'

export const useUserOtherInfo = (user?: Pick<IUserModel, 'willingToRelocate'>) => {
  try {
    if (!user) {
      return {
        shouldShowOtherInfo: false,
        willingToRelocateText: ''
      }
    }

    const { willingToRelocate } = user

    return {
      shouldShowOtherInfo: willingToRelocate,
      willingToRelocateText: willingToRelocate ? 'Willing to relocate' : ''
    }
  } catch (error) {
    console.log(error)
    return {
      shouldShowOtherInfo: false,
      willingToRelocateText: ''
    }
  }
}
